import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import MultilingualPlugin from "./vue-plugins/multilingual-plugin";
import DataFormatterPlugin from "./vue-plugins/data-formatter-pluging";
import FileExportPluging from "./vue-plugins/file-export-plugin";
import ResponsivePlugin from "./vue-plugins/responsive-plugin";
import EnergyDataPlugin from "./vue-plugins/energy-data-plugin";
import HotjarPlugin from "./vue-plugins/hotjar/hotjar-plugin";
import UtilsPlugin from "./vue-plugins/utils-plugin";
import UserPlugin from "./vue-plugins/user-plugin";

import Loader from "./components/shared-components/Loader.vue";
import Alert from "./components/shared-components/Alert.vue";
import CustomIcon from "./components/shared-components/custom-icon/CustomIcon.vue";
import Tooltip from "./components/shared-components/Tooltip.vue";

import { CustomDate } from "../../src/shared/domain/classes/custom-date";

const app = createApp(App);
app.config.globalProperties.CustomDate = CustomDate;
app
	.use(router)
	.use(MultilingualPlugin)
	.use(DataFormatterPlugin)
	.use(FileExportPluging)
	.use(ResponsivePlugin)
	.use(EnergyDataPlugin)
	.use(HotjarPlugin)
	.use(UtilsPlugin)
	.use(UserPlugin)
	.component("Loader", Loader)
	.component("Alert", Alert)
	.component("Icon", CustomIcon)
	.component("Tooltip", Tooltip)
	.mount("#app");
